import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientPageComponent } from './client-page/client-page.component';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientInspectionComponent } from './client-inspection/client-inspection.component';
import { TableModule } from 'app/shared/table/table.module';
import { ClientInspectionDetailsComponent } from './client-inspection-details/client-inspection-details.component';
import { PowerbiComponent } from './powerbi/powerbi.component';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavbarModule } from 'app/shared/navbar/navbar.module';
import { MENU, AQL_REPORT, NAV_ROLE_FILTER } from 'app/common/constants';
import { QuestionnaireComponent } from 'app/pages/questionnaire/questionnaire.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {SkippedInspectionsModule} from "../../shared/skipped-inspections/skipped-inspections.module";
import {ClientSkippedInspectionsComponent} from "./client-skipped-inspections/client-skipped-inspections.component";

const userRole = parseInt(localStorage.getItem('role'));
const getDefaultPage = (menu:any) => {
  let page:any;
  if (menu.pages.length === 1) {
    page = menu.pages[0];
  } else {
    page = menu.pages.find(p => p.default) || menu.pages[0];
  }
  return page;
}
const menu = MENU.filter((m:any) => {
  const roles = NAV_ROLE_FILTER[m.name];
  if (Array.isArray(roles) && roles.length > 0) {
    const roleSet = new Set(roles);
    return roleSet.has(userRole);
  }
  return true;
});
let pages: Array<any>;

if (Array.isArray(menu[0].pages) && menu[0].pages.length > 0) {
  pages = [];
  for (let m of menu) {
    const defaultPage = getDefaultPage(m);
    pages.push({
      path: m.name,
      component: PowerbiComponent,
      data: { reportId: defaultPage['report-id'], pageName: defaultPage['page-name'] }
    });
    if (m.pages.length > 1) {
      for (let subPage of m.pages) {
        pages.push({
          path: `${m.name}/${subPage.name}`,
          component: PowerbiComponent,
          data: { reportId: subPage['report-id'], pageName: subPage['page-name'] }
        });
      }
    }
  }

} else {
  pages = menu.map(m => {
    const comp = {};
    if (m['report-id']) {
      comp['component'] = PowerbiComponent;
      comp['data'] = { reportId: m['report-id'], pageName: m['page-name'] };
    } else if (m.name === 'request inspection') {
      comp['component'] = QuestionnaireComponent;
    } else if (m.name === 'inspection') {
      comp['component'] = ClientInspectionComponent;
      comp['data'] = { title: "AQL Inspection Plan" };
    } else if (m.name === 'skipped inspections') {
      comp['component'] = ClientSkippedInspectionsComponent;
      comp['data'] = {title: "AQL Inspection Plan"};
    }
    const path = typeof m.name === 'string'
    && m.name.includes('skipped inspections')
      ? m.name.split(' ').join('-')
      : m.name;
    return {
      path,
      ...comp
    };
  });
}

const routes: Routes = [
  {
    path: '',
    component: ClientPageComponent,
    children: [
      {
        path: 'inspection-detail/:id/:qcid', component: ClientInspectionDetailsComponent,
        data: { title: AQL_REPORT['title'] }
      },
      ...pages
    ]
  },
];

@NgModule({
  declarations: [
    ClientPageComponent,
    ClientInspectionComponent,
    ClientInspectionDetailsComponent,
    PowerbiComponent,
    QuestionnaireComponent,
    ClientSkippedInspectionsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    NgbModule,
    PowerBIEmbedModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    NavbarModule,
    NgMultiSelectDropDownModule.forRoot(),
    SkippedInspectionsModule
  ]
})

export class ClientModuleModule { }
